// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

/**
 * RoleBasedHomeRedirect Component
 *
 * Redirects users to their appropriate home page based on their role:
 * - Support users: /support-dashboard
 * - Regular advisors/admins: / (DashboardPage)
 */

import { Navigate } from 'react-router-dom';
import { useAdvisor } from '../contexts/AdvisorContext';
import { DashboardPage } from '../pages/DashboardPage';
import { Spinner } from '@loa/ui-components';

export function RoleBasedHomeRedirect() {
  const { loading, isSupport } = useAdvisor();

  // Show loading while determining user role
  if (loading) {
    return (
      <div style={{ marginTop: '3em' }}>
        <Spinner />
      </div>
    );
  }

  // If user is support staff, redirect to support dashboard
  if (isSupport) {
    return <Navigate to="/support-dashboard" replace />;
  }

  // Otherwise, show the regular dashboard
  return <DashboardPage />;
}

export default RoleBasedHomeRedirect;
